ixModuleRouting("impactx.awdtext", {
    "/awdtextlist": {
        template: "<ixa-award-decision-text-list></ixa-award-decision-text-list>",
        process: "AwardDecisionText",
        workspace: "content",
    },
    "/awdtextdetail/:id": {
        template: "<ixa-award-decision-text-detail></ixa-award-decision-text-detail>",
        process: "AwardDecisionText",
    },
});